import React from "react";
import ReactDOM from "react-dom/client";
import ReactGA from "react-ga4";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import { createBrowserHistory } from "history";
import App from "./App";
import "./index.css";
import * as serviceWorker from "@pages/Other/serviceWorker";
import { HelmetProvider } from "react-helmet-async";

const history = createBrowserHistory();

Sentry.init({
  dsn: "https://395f39725ebc465c8e8cdcc581558838@o4505357628997632.ingest.sentry.io/4505357630308352",
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.reactRouterV6Instrumentation(history),
    }),
  ],
  environment: process.env.NODE_ENV,
  tracesSampleRate: 1.0,
  enabled: window.location.hostname !== "localhost" && window.location.hostname !== "127.0.0.1",
});

ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID);
ReactGA.send({ hitType: "pageview", page: "/", title: "Dashboard" });
console.warn = () => { };
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

serviceWorker.unregister();
// import React, { useEffect } from "react";
// import ReactDOM from "react-dom/client";
// import ReactGA from "react-ga4";
// import * as Sentry from "@sentry/react";
// import App from "./App";
// import "./index.css";
// import * as serviceWorker from "@pages/Other/serviceWorker";
// import {
//   createRoutesFromChildren,
//   matchRoutes,
//   useLocation,
//   useNavigationType,
// } from "react-router-dom";
// const isLocalHost =
//   window.location.hostname === "localhost" ||
//   window.location.hostname === "127.0.0.1";

// Sentry.init({
//   dsn: "https://395f39725ebc465c8e8cdcc581558838@o4505357628997632.ingest.sentry.io/4505357630308352",
//   integrations: [
//     // See docs for support of different versions of variation of react router
//     // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
//     Sentry.reactRouterV6BrowserTracingIntegration({
//       useEffect,
//       useLocation,
//       useNavigationType,
//       createRoutesFromChildren,
//       matchRoutes,
//     }),
//     Sentry.replayIntegration(),
//   ],
//   environment: process.env.NODE_ENV,
//   // Performance Monitoring
//   tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
//   // Session Replay
//   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
//   enabled: !isLocalHost,
// });

// ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID);
// ReactGA.send({ hitType: "pageview", page: "/", title: "Dashboard" });

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// // // If you want your app to work offline and load faster, you can change
// // // unregister() to register() below. Note this comes with some pitfalls.
// // // Learn more about service workers: https://bit.ly/CRA-PWA

// serviceWorker.unregister();



